import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { I18nProvider } from '@/lib/i18n';
import { AttachmentUploaderProvider } from '@/lib/attachment-uploader';
import { ConfirmProvider, ToastProvider } from '@/components/ui';
import App from '@/App';
import '@/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <I18nProvider>
          <ConfirmProvider>
          <ToastProvider>
            <AttachmentUploaderProvider>
              <App />
            </AttachmentUploaderProvider>
          </ToastProvider>
        </ConfirmProvider>
        </I18nProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
